import { Wrench, FileText, Clock, Shield } from 'lucide-react';
import { useFadeUp } from '@/hooks/useFadeUp';

const reasons = [
  {
    icon: Wrench,
    title: 'Spécialistes de la réparation',
    description: 'Nous réparons, nous ne remplaçons pas systématiquement. Notre priorité : trouver la solution la plus économique et durable pour votre volet roulant.',
  },
  {
    icon: FileText,
    title: 'Devis clair et sans surprise',
    description: 'Diagnostic gratuit, devis détaillé avant toute intervention. Vous savez exactement ce que vous payez, pas de mauvaise surprise.',
  },
  {
    icon: Clock,
    title: 'Intervention rapide dans le Hainaut',
    description: 'Basés à Charleroi, nous couvrons tout le Hainaut. Intervention sous 24 à 48h pour les dépannages, encore plus rapide en cas d\'urgence.',
  },
  {
    icon: Shield,
    title: 'Garantie 10 ans',
    description: 'Toutes nos réparations et installations sont garanties 10 ans, pièces et main-d\'œuvre. Un engagement fort d\'un artisan local.',
  },
];

export function WhyUs() {
  const ref = useFadeUp();

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div ref={ref} className="fade-up max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="section-title">Pourquoi nous choisir ?</h2>
          <p className="section-subtitle">
            Un artisan local de confiance, spécialisé dans la réparation de volets roulants
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {reasons.map((reason, i) => {
            const Icon = reason.icon;
            return (
              <div key={i} className="card border border-background-200 text-center">
                <div className="w-12 h-12 rounded-xl bg-accent-50 flex items-center justify-center mx-auto mb-4">
                  <Icon className="w-6 h-6 text-accent-500" />
                </div>
                <h3 className="font-heading font-semibold text-foreground-700 text-sm md:text-base mb-2">
                  {reason.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {reason.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}